module.exports = __webpack_public_path__ + "static/img/zz-03.25747543.jpg";